<script lang="ts">
  import { closeModal } from '$lib/utils/modals';
	import { clickOutside } from '$lib/events/clickOutside';
	import { Icon } from '$lib/components/atoms/Icon';
	import { Button } from '$lib/components/atoms/Button';
	import { useCTAFlow } from '$lib/utils/cta-flow';
	import { goto } from '$app/navigation';
	import { addLeadingSlash } from '$lib/utils/formatter';

  export let isOpen: boolean = false;
  export let isSuccess: boolean = false;
  export let callBackPath: string | null = null;

  const handleCallBack = () => {

		closeModal();
		const ctaFlow = useCTAFlow();
    if (ctaFlow.shouldGoToCompletionForm(true)) {
      goto(`/registrati/completion?callback=${callBackPath}`, { replaceState: true });
    } else if (callBackPath) {
      goto(addLeadingSlash(callBackPath), { replaceState: true });
    } else {
      goto('/');
    }
	};

</script>

{#if isOpen}
  <div
    class="modal"
    role="dialog"
    aria-labelledby="Contattaci!"
  >
    <div
      class="modal-dialog"
      use:clickOutside
      on:click_outside={closeModal}
    >
      <div class="modal-header">
        <div>
          <button
            class="close"
            aria-label="Chiudi"
            on:click={closeModal}
          >
            <Icon icon="close" />
          </button>
        </div>
      </div>
      <div class="modal-body">
        {#if isSuccess}
          <h5>Grazie per il tuo messaggio. <br/>Ti risponderemo al pi&ugrave; presto.</h5>
        {:else}
          <h5>Si è verificato un problema durante l'invio. Prova a modificare i dati inseriti oppure riprova in un secondo momento.</h5>
        {/if}
        {#if callBackPath}
          <div class="mt-8 text-center">
            <Button compact on:click={handleCallBack}>Close</Button >
          </div>
        {/if}
      </div>
    </div>
  </div>
{/if}

<style type="text/scss" lang="scss" scoped>
	.modal {
		@apply fixed inset-0;
    @apply flex flex-col;
		@apply md:items-center md:justify-center;
    @apply z-modal;
	}
	.modal-dialog {
		@apply bg-white;
    @apply h-full;
    @apply flex flex-col;
    @apply max-w-xl;
    @apply md:h-auto md:max-h-[90vh];
		@apply relative;
		@apply rounded md:rounded-lg;
		@apply shadow-xl;
		@apply p-6;
		@apply transform transition-all;
		@apply sm:my-8 sm:align-middle;
	}
	.modal-header {
		@apply flex items-start justify-end;
    @apply bg-white;
		@apply mb-2;
	}
	.modal-title {
		@apply text-2xl md:text-5xl;
		@apply leading-tight font-medium;
		@apply text-gray-900;
		@apply mt-2;
	}
	.modal-body {
		@apply flex-grow;
	}
	.close {
    @apply ml-auto;
    @apply transition-opacity duration-200;
    @apply hover:opacity-75;
	}
</style>
